import $ from "jquery";
var ReactDOMServer = require("react-dom/server");

const getCode = (items, head, bodyAttributes, wrapperAttributes, preheader) => {
  var html = "";

  for (var x = 0; x < items.length; x++) {
    var htmlCode = ReactDOMServer.renderToString(items[x].component);

    html += `${htmlCode}`;
  }

  var code = mergeHTML(
    html,
    head,
    bodyAttributes,
    wrapperAttributes,
    preheader
  );
  return code;
};

const mergeHTML = (
  wrappedHTML,
  head,
  bodyAttributes,
  wrapperAttributes,
  preheader
) => {
  var htmlDoc = new DOMParser().parseFromString(wrappedHTML, "text/html");

  var commentNodes = htmlDoc.querySelectorAll("comment");
  for (var y = 0; y < commentNodes.length; y++) {
    commentNodes[y].replaceWith(...commentNodes[y].childNodes);
  }

  var sectionNodes = htmlDoc.querySelectorAll("section");
  for (var z = 0; z < sectionNodes.length; z++) {
    sectionNodes[z].replaceWith(...sectionNodes[z].children);
  }

  $("head", htmlDoc).html(head[0].innerHTML);

  //copy body attributes over
  $.each(bodyAttributes, function () {
    $("body", htmlDoc).attr(this.name, this.value);
  });

  //add the original wrapper inside the body tag
  var mjmlWrapperDiv = document.createElement("div");
  $.each(wrapperAttributes, function () {
    $(mjmlWrapperDiv).attr(this.name, this.value);
  });

  //using wrapInner
  var bod = $("body", htmlDoc).get();
  $(bod[0]).wrapInner(mjmlWrapperDiv);

  //insert preheader back in at the top
  $("body", htmlDoc).prepend(preheader);

  console.log(htmlDoc);
  return htmlDoc;
};

export default getCode;
